import { Box, useTheme } from "@mui/material"
import { getExpirationColor, getExpirationDate, getExpirationMessage, getExpirationTimeMessage } from "./utils/helpers"

type DiscontinuedExpirationDate = {
  date: string,
  status: number,
  children: JSX.Element | null,
}

const DiscontinuedExpirationDate = (props: DiscontinuedExpirationDate) => {
  const { date, status, children } = props
  const theme = useTheme()

  const dateYear = date ? date.slice(0, 4) : false

  const expirationDate = getExpirationDate(date)
  const formattedDate = expirationDate.format('M/D/YY')

  return (
    <>
      {
        dateYear && dateYear !== '1900'
          ? (
              <Box className="flex flex-align-center c-g-8" sx={{ color: getExpirationColor(status, theme) }}>
                Discontinued and {getExpirationMessage(expirationDate)} {getExpirationTimeMessage(expirationDate)} on {formattedDate}
                { children }
              </Box>            
            )
          : null
      }
    </>
  )
}

export default DiscontinuedExpirationDate
